export default "__VITE_ASSET__eeab6372__"